import { Icon } from "@iconify/react"
import { Group, Title } from "@mantine/core"
import { useProduct } from "../../../lib/tenant"
import classes from "./SectionHeader.module.css"

const LEX_ICONS: Record<string, string> = {
  summary: "tabler:file-description",
  decisions: "tabler:checks",
  action_points: "tabler:bolt",
  open_questions: "tabler:help-circle",
  topics: "tabler:tags",
  attendee_contributions: "tabler:users-group",
  speaker_quotes: "tabler:message-quote",
  sentiment: "tabler:mood-smile",
  quality: "tabler:chart-bar",
}

const VOX_ICONS: Record<string, string> = {
  recap: "game-icons:scroll-unfurled",
  scenes: "game-icons:dungeon-gate",
  characters: "game-icons:cowled",
  quests: "game-icons:treasure-map",
  memorable_moments: "game-icons:star-formation",
  mood: "game-icons:drama-masks",
  loot: "game-icons:chest",
  dm_notes: "game-icons:quill-ink",
}

interface IProps {
  id: string
  label: string
}

export function SectionHeader({ id, label }: IProps): React.ReactElement {
  const product = useProduct()
  // Icon SET still varies by product (different glyph names per brand) — that's
  // data, not styling. The COLOUR divergence lives in the CSS module, scoped by
  // [data-product], so the component doesn't branch on the brand to pick a var.
  const icon = product === "voxcanon" ? VOX_ICONS[id] : LEX_ICONS[id]

  return (
    <Group gap={7} mb="sm" align="center">
      {icon && <Icon icon={icon} width={16} height={16} className={classes.icon} />}
      <Title order={4} style={{ lineHeight: 1 }}>
        {label}
      </Title>
    </Group>
  )
}
